import { DispatchLoading, DispatchType, ResponseValid } from 'domain/utils/ReactUtils'
import { AprovarPedidoService } from '../../../services/aprovarPedido/aprovarPedidoService';
import { AppThunk } from 'base/src/utils/reducerUtil';
import { StateType } from 'domain/types/base/base';
import {
	CAMPANHA_RESGATE_APROVAR,
	CAMPANHA_RESGATE_APROVAR_BULK,
	CAMPANHA_RESGATE_REPROVAR,
	CAMPANHA_RESGATE_REPROVAR_BULK,
} from '../../../types/aprovarPedido/aprovarPedido';
import { _UserData, UserDataBaseEnum } from 'base/src/infra/storage/localStorage';

const _AprovarPedidoService = new AprovarPedidoService();

export function AprovarResgate(campanhaPedidoResgateId: number, statusAtual: number, status: number, motivo: string): AppThunk {
	return async (dispatch) => {
		dispatch(DispatchLoading(CAMPANHA_RESGATE_APROVAR, DispatchType.LOADING, 'Atualizando status...', StateType.Master))

		const asyncResponse = await _AprovarPedidoService.AprovarPedido(
			campanhaPedidoResgateId,
			statusAtual,
			_UserData.Get(UserDataBaseEnum.UsuarioAcesso),
			_UserData.Get(UserDataBaseEnum.EmpresaID),
			status,
			_UserData.Get(UserDataBaseEnum.EmpresaID),
		)

		if (ResponseValid(asyncResponse)) {
			dispatch({
				payload: asyncResponse,
				type: CAMPANHA_RESGATE_APROVAR
			})
		} else {
			dispatch({
				payload: asyncResponse,
				type: CAMPANHA_RESGATE_APROVAR
			})
			dispatch(DispatchLoading(CAMPANHA_RESGATE_APROVAR, DispatchType.ERROR, "Erro ao mudar status!", StateType.Master))
		}
	}
}

// Is this being used?
export function ReprovarResgate(campanhaPedidoResgateId: number, motivo: string, usuario: string): AppThunk {
	return async (dispatch) => {
		dispatch(DispatchLoading(CAMPANHA_RESGATE_REPROVAR, DispatchType.LOADING))

		const asyncResponse = await _AprovarPedidoService.ReprovarPedido(campanhaPedidoResgateId, motivo, usuario)

		if (ResponseValid(asyncResponse, false, dispatch)) {
			dispatch({
				payload: asyncResponse,
				type: CAMPANHA_RESGATE_REPROVAR
			})
			dispatch(DispatchLoading(CAMPANHA_RESGATE_REPROVAR, DispatchType.SUCCESS, "Resgate reprovado com sucesso!", StateType.Local))
		}
	}
}

export function AprovarResgateBulk(campanhaPedidoResgateIds: number[], status: number, motivo: string): AppThunk {
	return async (dispatch) => {
		dispatch(DispatchLoading(CAMPANHA_RESGATE_APROVAR_BULK, DispatchType.LOADING, 'Atualizando pedidos...', StateType.Master))

		const asyncResponse = await _AprovarPedidoService.AprovarPedidoBulk(
			campanhaPedidoResgateIds,
			_UserData.Get(UserDataBaseEnum.UsuarioAcesso),
			Number(_UserData.Get(UserDataBaseEnum.EmpresaID)),
			status,
			motivo,
		)

		if (ResponseValid(asyncResponse)) {
			dispatch({
				payload: asyncResponse,
				type: CAMPANHA_RESGATE_APROVAR_BULK
			})

			const total = (asyncResponse as { Total: number }).Total
			const sucessos = (asyncResponse as { Successes: number[] }).Successes.length
			const falhas = (asyncResponse as { Failures: unknown[] }).Failures.length

			if (falhas === 0) {
				dispatch(DispatchLoading(CAMPANHA_RESGATE_APROVAR_BULK, DispatchType.SUCCESS, `${sucessos} pedido(s) aprovado(s) com sucesso!`, StateType.Master))
			} else {
				dispatch(DispatchLoading(CAMPANHA_RESGATE_APROVAR_BULK, DispatchType.ERROR, `${sucessos}/${total} aprovados. ${falhas} falharam.`, StateType.Master))
			}
		} else {
			dispatch(DispatchLoading(CAMPANHA_RESGATE_APROVAR_BULK, DispatchType.ERROR, 'Erro ao aprovar pedidos.', StateType.Master))
		}
	}
}

export function ReprovarResgateBulk(campanhaPedidoResgateIds: number[], motivo: string): AppThunk {
	return async (dispatch) => {
		dispatch(DispatchLoading(CAMPANHA_RESGATE_REPROVAR_BULK, DispatchType.LOADING, 'Reprovando pedidos...', StateType.Master))

		const asyncResponse = await _AprovarPedidoService.ReprovarPedidoBulk(
			campanhaPedidoResgateIds,
			motivo,
			_UserData.Get(UserDataBaseEnum.UsuarioAcesso),
		)

		if (ResponseValid(asyncResponse)) {
			dispatch({
				payload: asyncResponse,
				type: CAMPANHA_RESGATE_REPROVAR_BULK
			})

			const total = (asyncResponse as { Total: number }).Total
			const sucessos = (asyncResponse as { Successes: number[] }).Successes.length
			const falhas = (asyncResponse as { Failures: unknown[] }).Failures.length

			if (falhas === 0) {
				dispatch(DispatchLoading(CAMPANHA_RESGATE_REPROVAR_BULK, DispatchType.SUCCESS, `${sucessos} pedido(s) reprovado(s) com sucesso!`, StateType.Master))
			} else {
				dispatch(DispatchLoading(CAMPANHA_RESGATE_REPROVAR_BULK, DispatchType.ERROR, `${sucessos}/${total} reprovados. ${falhas} falharam.`, StateType.Master))
			}
		} else {
			dispatch(DispatchLoading(CAMPANHA_RESGATE_REPROVAR_BULK, DispatchType.ERROR, 'Erro ao reprovar pedidos.', StateType.Master))
		}
	}
}
